"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
var CellStyleMerger = /** @class */ (function () {
    function CellStyleMerger() {
    }
    CellStyleMerger.mergeTextStyles = function (textStyles) {
        var resolvedStyle = new idm_report_export_service_client_js_1.TextStyleDto();
        textStyles.forEach(function (style) {
            if (style.align !== undefined) {
                resolvedStyle.align = style.align;
            }
            if (style.backgroundColor) {
                resolvedStyle.backgroundColor = style.backgroundColor;
            }
            if (style.color) {
                resolvedStyle.color = style.color;
            }
            if (style.fontName) {
                resolvedStyle.fontName = style.fontName;
            }
            if (style.fontSize) {
                resolvedStyle.fontSize = style.fontSize;
            }
            if (style.isBold !== undefined) {
                resolvedStyle.isBold = style.isBold;
            }
            if (style.isItalic !== undefined) {
                resolvedStyle.isItalic = style.isItalic;
            }
            if (style.isUnderline !== undefined) {
                resolvedStyle.isUnderline = style.isUnderline;
            }
            if (style.width) {
                resolvedStyle.width = style.width;
            }
        });
        return resolvedStyle;
    };
    return CellStyleMerger;
}());
exports.CellStyleMerger = CellStyleMerger;
//# sourceMappingURL=cell-style-merger.js.map